import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-view-html',
  templateUrl: './view-html.component.html',
  styleUrls: ['./view-html.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewHtmlComponent implements OnInit {

  @Input()
  set html(input: string) {
    this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(input || '');
  }
  
  safeHTML: SafeHtml;

  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit() {
  }
}
